import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import AdminApp from './AdminApp';
import { initializeAdminMonitoring } from './monitoring';

void initializeAdminMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>,
);
